import FileUploadClient from "../components/fileUpload/FileUploadClient.js"
import ClientOverviewPanel from "./panels/ClientOverviewPanel.js";
import "../styling/ClientPortal.css";
import { useContext, useEffect, useState } from "react";
import { EventDataContext } from "./EventDataContext";
import otherPhoto from "../images/BoothBloom_Banner_Business.jpg";
import axios from "axios";
import { useSelector } from "react-redux";
import RightSidebar from "./RightSidebar"; // <-- use the shared sidebar

const ClientOverview = ({ brandingColours, clientId, clientData }) => {
  const { EventData } = useContext(EventDataContext);
  const user = useSelector((state) => state.auth.user);
  const businessId=user?.businessId
  const [isEditing, setIsEditing] = useState(false);
  const [clientOverviewText, setClientOverviewText] = useState("");

useEffect(() => {
  if (clientData?.overview && businessId) {
    const matchedOverview = clientData.overview.find(
      (item) => item.businessId?.toString() === businessId.toString()
    );

    if (matchedOverview) {
      setClientOverviewText(matchedOverview.body || "");
    }
  }
}, [clientData, businessId]);

  const handleEditClick = async () => {
    if (isEditing) {
      try {
        await axios.put(`${process.env.REACT_APP_API_URL}/update-client-overview/${clientId}`, {
          body: clientOverviewText,
        }, {withCredentials:true});
        alert("Overview Updated Succesfully")
       
      } catch (error) {
        console.error("Failed to save client overview:", error);
      }
    }
    setIsEditing(!isEditing);
  };

  return (
    <div className="overviewClientContainer overviewClientContainer--withSidebar">
      <div className="overviewClientLeftPanel" style={{ borderRight: '1px solid #d9d9d9', paddingBottom: "25px"}}>
         <button
            onClick={handleEditClick}
            style={{
              position: "absolute",
              top: '94px',
              right: '68px',
              width: '189px',
              height: '41px',
              padding: "5px",
              background: 'transparent linear-gradient(90deg, #1C1154 0%, #260F99 100%) 0% 0% no-repeat padding-box',
              boxShadow: '0px 2px 6px #00000029',
              borderRadius: '5px',
              cursor: "pointer",
              color:'#fff',
              fontSize:'15px',
            }}
          >
            {isEditing ? "Save" : "Edit Client Overview"}
          </button>
        <div style={{ position: 'relative', width: '100%', height: '224px' }}>
          <img
            src={otherPhoto }
            alt="cover"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            className="overviewClientLeftPanelImage"
          />
        </div>

        <div style={{ padding: "20px", fontWeight: "300", position: "relative" }} className="event-overview-div">
          <h2 style={{ color: "#000000", marginBottom: "10px" }}>Client Overview</h2>

          {isEditing ? (
            <textarea
              value={clientOverviewText}
              onChange={(e) => setClientOverviewText(e.target.value)}
              rows={6}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "14px",
              }}
            />
          ) : (
            <p style={{ whiteSpace: "pre-wrap", marginTop: "10px", fontSize: "14px" }}>
              {clientOverviewText || "No overview provided."}
            </p>
          )}
        </div>

        <div style={{ marginLeft: "25px", marginRight: "25px" }} className="event-overview-div">
          <h2 style={{ fontWeight: "400", color: "#000000", marginTop: "30px" }}>
            Documents &amp; Files
          </h2>
          <FileUploadClient brandingColours={brandingColours} eventId={EventData._id} clientId={clientId} />
        </div>
      </div>

          <RightSidebar>
        <ClientOverviewPanel brandingColours={brandingColours} clientId={clientId} />
        </RightSidebar>
      
    </div>
  );
};

export default ClientOverview;
